import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
              最新文章
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              最新的导航设计技巧与开发实践
            </p>
          </div>
          <Link
            to="/category/quick-start"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl bg-background-100/70 border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-all duration-300 hover:translate-y-[-4px]"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <span className="text-xs text-primary-600 font-medium bg-primary-50 px-2.5 py-1 rounded-full">
                    {article.category === 'quick-start' ? '快速入门' : 
                     article.category === 'layout-design' ? '布局设计' :
                     article.category === 'custom-theme' ? '主题定制' :
                     article.category === 'responsive' ? '响应式适配' : '高级技巧'}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.author} · {article.readTime}</span>
                  <span className="text-xs text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    阅读全文 →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}